import { envType } from '@atlassiansox/analytics-web-client';
import { AnalyticsClient, setAnalyticsClient } from '@databases/analytics';
import { type BridgeData } from '@databases/database-state/state/bridge-data';
import { perf } from '@databases/logs/performance';
import { getService } from '@databases/service-container';

function getAnalyticsEnvironment() {
  if (process.env.MODE === 'test') {
    return envType.LOCAL;
  }

  const mode = process.env.MODE ?? 'local';

  // Map environment strings to valid envType values
  if (mode.endsWith('dev') || mode === 'dev') {
    return envType.DEV;
  }

  if (mode.startsWith('stg-') || mode === 'staging') {
    return envType.STAGING;
  }

  if (mode.startsWith('prod-') || mode === 'prod') {
    return envType.PROD;
  }

  // Default to local for any other values
  return envType.LOCAL;
}

export const initializeAnalytics = ({
  cloudId,
  spaceId,
  accountId,
}: Pick<BridgeData, 'cloudId' | 'spaceId'> & {
  accountId: BridgeData['identity']['accountId'];
}) => {
  perf.timeLog('app-initialization', 'analytics');

  const env = getAnalyticsEnvironment();
  const analyticsClient = new AnalyticsClient({
    cloudId: env === envType.LOCAL || !env ? undefined : cloudId,
    env,
    spaceId,
    userId: accountId,
    version: process.env.SENTRY_RELEASE ?? 'development',
    concurrentEditorCountResolver: () => {
      return Math.max(0, getService('PresenceState').accountIdToParticipantsMap.size - 1);
    },
  });

  setAnalyticsClient(analyticsClient);
};
